import { loyaltyApi } from '../services/loyaltyApi';

export const loyaltyPolicyQueryKey = ['loyalty', 'policy'] as const;

export function loyaltyPolicyQueryOptions() {
  return {
    queryKey: loyaltyPolicyQueryKey,
    queryFn: () => loyaltyApi.getPolicy(),
    staleTime: 60_000,
  };
}
